export const commons = {
  languages: {
    A1: 'A1 — початковий',
    A2: 'A2 — нижче середнього',
    B1: 'B1 — середній',
    B2: 'B2 — вище середнього',
    C1: 'C1 — просунутий',
    C2: 'C2 — професійний',
    Native: 'Рідна мова'
  },
  roles: {
    club: 'Клуб',
    artist: 'Артист',
    admin: 'Адміністратор'
  },
  artistJobs: {
    Hostess: 'Hostess',
    GoGo: 'Go-go',
    Strip: 'Strip'
  },
  schedule: {
    Monday: 'Понеділок',
    Tuesday: 'Вівторок',
    Wednesday: 'Середа',
    Thursday: 'Четвер',
    Friday: 'П’ятниця',
    Saturday: 'Субота',
    Sunday: 'Неділя'
  },
  paymentFrequency: {
    Daily: 'Щодня',
    Weekly: 'Щотижня',
    Monthly: 'Щомісяця'
  },
  flightPaymentType: {
    Club: 'За рахунок клубу',
    Artist: 'За рахунок артиста',
    Credit: 'У кредит',
    Agreement: 'За домовленістю',
    Compensation: 'Компенсація'
  },
  artistConsumation: {
    label: 'Консумація',
    Active: 'Активна',
    Passive: 'Пасивна'
  },
  workItemType: {
    Request: 'Заявки',
    Invite: 'Запрошення'
  },
  workItemStatus: {
    Pending: 'Очікується',
    Accepted: 'Прийнято',
    Rejected: 'Відхилено',
    Withdrawn: 'Відкликано',
    Expired: 'Прострочено',
    ContractOngoing: 'Контракт діє',
    ContractRequestedEndDate: 'Запит на завершення контракту',
    FinishingContract: 'Контракт завершується',
    ContractCompleted: 'Контракт завершено',
    ClubSetEndDate: 'Клуб установив дату завершення',
    Cancelled: 'Скасовано'
  },
  artistStatuses: {
    LookingForWork: 'У пошуку',
    OnContract: 'На контракті',
    FinishingContract: 'Завершую контракт',
    OnVacation: 'У відпустці',
    HiddenFromSearch: 'Приховано з пошуку'
  },
  loading: {
    generic: 'Дані завантажуються...',
    requests: 'Заявки завантажуються...',
    invites: 'Запрошення завантажуються...'
  },
  flightCompensationOptions: {
    oneMonth: 'За 1 місяць контракту',
    twoMonths: 'За 2 місяці контракту',
    threeMonths: 'За 3 місяці контракту',
    sixMonths: 'Після 6 місяців контракту клуб купує зворотний квиток',
    backTicket: 'Зворотний квиток'
  },
  transportFromAirport: {
    label: 'Трансфер з аеропорту/станції',
    options: {
      clubOrganizes: 'Організовує клуб',
      artistSelf: 'Артист дістається самостійно'
    }
  },
  notFound: {
    generic: 'Порожньо.',
    requests: 'Ще немає заявок.',
    invites: 'Ще немає запрошень.',
    artists: 'Поки що список артистів порожній.',
    search:
      'Ми не знайшли клуб за вашим запитом. Повідомте, будь ласка, підтримку, щоб ми могли покращити пошук.'
  },
  artistParametres: {
    weight: 'Вага',
    height: 'Зріст',
    body: 'Тип фігури',
    chest: 'Обхват грудей',
    waist: 'Обхват талії',
    hips: 'Обхват стегон'
  },
  dressCodeOptions: {
    strip: 'Strip',
    underwear: 'Білизна',
    longDress: 'Довга сукня',
    body: 'Боді',
    shortDress: 'Коротка сукня'
  },
  time: {
    years:
      '{count, plural, one {# рік} few {# роки} many {# років} other {# років}}',
    months:
      '{count, plural, one {# місяць} few {# місяці} many {# місяців} other {# місяців}}',
    days:
      '{count, plural, one {# день} few {# дні} many {# днів} other {# днів}}'
  },
  contact_support: 'Потрібна допомога? Зв’яжіться зі службою підтримки',
  success_send_data: 'Дані успішно надіслані',
  show_full: 'Показати повністю',
  worked_for: 'Працювала у',
  club_reviews: 'Відгуки про клуб',
  club_response: 'Відповідь клубу',
  response: 'Відповісти',
  send: 'Надіслати',
  cm: 'см',
  kg: 'кг',
  no_rating_yet: 'Ще немає рейтингу',
  rating_allow: 'Артисти можуть оцінити клуб лише через 21 день роботи',
  rating: 'Рейтинг',
  rating_popup_header_1: 'Ваш контракт у клубі',
  rating_popup_header_2: 'завершено',
  contractWeeks:
    '{count, plural, one {# тиждень} few {# тижні} many {# тижнів} other {# тижнів}}',
  rating_popup_text:
    'Нам та іншим артистам важливо знати вашу думку про це місце. Будь ласка, оцініть роботу в цьому клубі.',
  error_rating: 'Помилка рейтингу',
  no_rating: 'Немає елемента для оцінки цього клубу або його вже оцінено',
  housing_quality: 'Якість житла',
  dressing_quality: 'Якість гримерки',
  management: 'Керівництво та персонал',
  anonymous: 'Залишити відгук анонімно',
  rate_work: 'Оцінити роботу в цьому клубі',
  submit: 'Надіслати',
  years: 'роки',
  allow_note: 'Дозволити сповіщення',
  allow_note_1:
    'Дозвольте сповіщення для коректної роботи платформи, щоб не пропустити важливі події:',
  allow_note_2: 'Заявки та запрошення',
  allow_note_3: 'Відповіді від клубів',
  allow_note_4: 'Повідомлення від артистів або менеджерів',
  allow_note_5: 'Ми надсилаємо лише робочі сповіщення — без спаму.',
  'follow-us-in-social': 'Слідкуйте за нами в соціальних мережах:',
  continue: 'Продовжити',
  'continue-with-google': 'Продовжити з Google',
  artistHiringIsOpen: 'Набір артистів відкрито',
  artistHiringIsClosed: 'Набір артистів закрито',
  acceptWithExperience: 'Приймаємо без досвіду',
  dontAcceptWithoutExperience: 'Не приймаємо без досвіду',
  info: 'Інформація',
  copyLink: 'Скопіювати посилання',
  withExperience: 'З досвідом',
  withouthExperience: 'Без досвіду',
  agree: 'Я згоден з умовами',
  change: 'Змінити',
  add: 'Додати',
  citizenship: 'Громадянство',
  selectCountry: 'Виберіть країну',
  save: 'Зберегти',
  'save-and-continue': 'Зберегти та продовжити',
  edit: 'Редагувати',
  portfolio: 'Портфоліо',
  close: 'Закрити',
  closed: 'Зачинено',
  finish: 'Завершити',
  help: 'Допомога',
  logout: 'Вийти',
  country: 'Країна',
  place: 'Місце',
  deleteAccount: 'Видалити акаунт',
  changePassword: 'Змінити пароль',
  hide: 'Приховати',
  delete: 'Видалити',
  exit: 'Так, хочу вийти',
  'undo-to-account': 'Назад до акаунту',
  location: 'Місцезнаходження',
  language: 'Мова',
  reviews: 'Відгуки',
  parametres: 'Параметри',
  about: 'Про себе',
  my: 'Мій',
  photo: 'Фото',
  video: 'Відео',
  experience: 'Досвід',
  galery: 'Галерея',
  write: 'Написати',
  yes: 'Так',
  step: 'Крок',
  no: 'Ні',
  or: 'Або',
  resend: 'Надіслати ще раз',
  open: 'ВІДКРИТО',
  cancel: 'Скасувати',
  need: 'Потрібно',
  dontNeed: 'Не потрібно',
  endWork: 'Кінець роботи',
  startDate: 'Дата початку роботи',
  endDate: 'Дата завершення роботи',
  vacancy: 'Вакансія',
  creditation: 'Кредитування квитків',
  aroundTheClock: 'Цілодобово',
  flightTickets: 'Авіаквитки',
  ticketCreditation: 'Кредитування квитків',
  crazyMenu: 'Crazy-меню',
  tea: 'Чай',
  show: 'Шоу',
  deposit: 'Депозит',
  guarantee: 'Гарантія',
  rate: 'Оцінити',
  clubFee: 'Плата клубу',
  separated: 'Окремо',
  forShift: 'За зміну',
  required: "Обов’язково",
  optional: 'Необов’язково',
  quantity: 'Кількість',
  withouthExprience: 'Без досвіду',
  choreographerInClub: 'Наявність хореографа в клубі',
  photoshootParticipation: 'Участь у фотосесіях',
  artistsInShift: 'Артистів у зміну',
  scenes: 'Сцени',
  dynamicPole: 'Динамічний пілон',
  staticPole: 'Статичний пілон',
  artistTraining: 'Навчання артистів',
  teching: 'Навчання',
  dressCodeForArtists: 'Дрес-код для артистів',
  dressCode: 'Дрес-код',
  rentPayment: 'Оплата житла',
  utilitiesPayment: 'Комунальні платежі',
  clubProvidedAccommodation: 'Проживання від клубу',
  housingPhoto: 'Фото житла',
  noteEditLater: 'Зміни можна внести пізніше',
  paydByArtist: 'Артист',
  paydByClub: 'Клуб',
  peopleInRoom: 'Людей у кімнаті',
  uploadFromDevice: 'Завантажити з пристрою',
  uploadManyFromDevice: 'Завантажити кілька фото з пристрою',
  selectMainPhoto: 'Виберіть головне фото',
  photoParams: 'Розмір фото не повинен перевищувати {size} МБ',
  videoParams:
    'Розмір відео не повинен перевищувати {size} МБ. Підтримувані формати: MP4, QuickTime.',
  general: 'Загальні',
  payments: 'Виплати',
  full: 'Повний',
  topless: 'Топлес',
  gogo: 'Go-go',
  crazymenu: 'Crazy-меню',
  continueFilling: 'Продовжити заповнення',
  exitShort: 'Вийти',
  search: 'Пошук',
  other: 'Інше',
  foreignLanguages: 'Іноземні мови',
  dancer: 'Танцівниця',
  untilNow: 'Дотепер',
  invite: 'Запросити',
  cancelInvite: 'Скасувати запрошення',
  dateFormatPlaceholder: 'дд.мм.рр',
  askArtist: 'Поставити запитання артисту',
  askClub: 'Поставити запитання клубу',
  reject: 'Відхилити',
  accept: 'Прийняти',
  confirm: 'Підтвердити',
  iConfirm: 'Я підтверджую',
  workAt: 'Працює у',
  setLastDate: 'Встановити останню дату',
  lastWorkDay: 'Останній робочий день',
  cancelArrangement: 'Скасувати домовленість',
  back: 'Назад',
  wantedVacancy: 'Бажані вакансії',
  addClub: 'Додати клуб',
  goToInvitation: 'Перейти до запрошення',
  goToRequest: 'Перейти до заявки',
  vacancyConsider: 'Які вакансії ви розглядаєте?',
  super: 'Супер',
  clubLocation: 'Місцезнаходження клубу',
  specify: 'Уточнити',
  housing: 'Житло',
  position: 'Посада',
  guest: 'Гість',
  workingHours: 'Години роботи',
  isPaydByClub: 'Оплачується клубом',
  isntPaydByClub: 'Не оплачується клубом',
  utilityPayments: 'Комунальні платежі',
  payment: 'Оплата',
  request: 'Заявка',
  penalties: 'Штрафи',
  aboutClub: 'Про клуб',
  sendRequest: 'Надіслати заявку',
  cancelRequest: 'Скасувати заявку',
  profile: 'Профіль',
  chat: 'Чат',
  housigInClubApartsRequired: 'Потрібне житло від клубу'
};
